export const API_KEY = 'AIzaSyCchTKaN8QZIDF5q5_qZdJYol5AeNS2764'
